import React from 'react';

const decodeEntities = (str) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.documentElement.textContent;
};

const ErrorMessage = ({ error }) => {
    
    let errorText;
    if (error instanceof Error) {
        errorText = error.message;
    } else if (typeof error === 'string') {
        errorText = error;
    } else {
        errorText = `${error}`;
    }

    const cleanErrorText = errorText.replace(/<\/?[^>]+(>|$)/g, "");
    const decodedErrorText = decodeEntities(cleanErrorText);

    return <div className="alert alert-danger" role="alert">{decodedErrorText}</div>
}

export default ErrorMessage;
